import { render } from "./AdaptiveReport.vue?vue&type=template&id=6c3272dd&scoped=true"
import script from "./AdaptiveReport.vue?vue&type=script&lang=js"
export * from "./AdaptiveReport.vue?vue&type=script&lang=js"

import "./AdaptiveReport.vue?vue&type=style&index=0&id=6c3272dd&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3272dd"]])

export default __exports__